import CodeInput from "./CodeInput";
import "./CodeInput.css";

export default CodeInput;